import { ampli } from '~shared/analytics';
import { config } from '~shared/config';

import { findOrCreateWuid } from '@breeze/web-lib-wuid';

import { DefaultPropsPlugin } from '../lib/default-props-plugin';

type GetDynamicUserProps = () => Record<string, unknown> | null;

export const initAmpli = async (getDynamicUserProps: GetDynamicUserProps) => {
  const isAutomatedTest = navigator.webdriver;

  await ampli.load({
    client: {
      apiKey: config.amplitudeKey,
      configuration: {
        autocapture: false,
        appVersion: config.version,
      },
    },
    disabled: !config.isAmplitudeEnabled || isAutomatedTest,
  }).promise;

  ampli.client.add(
    new DefaultPropsPlugin({
      defaultProps: {
        wuid: findOrCreateWuid(),
      },
      getDynamicProps: () => {
        return { ...getDynamicUserProps() };
      },
    })
  );

  ampli.client.setUserId(findOrCreateWuid());
};
